<template>
  <div>
    <Modal
      ref="modal"
      title="Add cities"
      action="Save"
      action-color="indigo"
      @close-modal="handleCancel"
      @handle-action="handleCreate"
    >
      <CitiesInput v-model="selectedCities" label="Location" />
    </Modal>
  </div>
</template>

<script>
import Modal from '../shared/Modal.vue';
import StatesUtility from '../../utilities/states.js';
import CitiesInput from '../shared/CitiesInput.vue';
import { createJobLocation } from '../../api/jobs.ts';

export default {
  components: {
    Modal,
    CitiesInput,
  },
  props: {
    record: Object,
    initialCities: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedCities: [],
      states: StatesUtility.getStates(),
    };
  },
  methods: {
    isDuplicateCity(newCity) {
      return this.initialCities.some(
        existingCity =>
          existingCity.city.toLowerCase() === newCity.city.toLowerCase() &&
          existingCity.state.toLowerCase() === newCity.state.toLowerCase()
      );
    },
    validateLocation() {
      if (!this.selectedCities.length) {
        this.$store.commit('general/showAlert', {
          alertType: 'error',
          alertTitle: 'No cities selected',
          alertDescription: 'Please select at least one city.',
        });
        return false;
      }

      const duplicates = this.selectedCities.filter(city => this.isDuplicateCity(city));
      if (duplicates.length > 0) {
        this.$store.commit('general/showAlert', {
          alertType: 'error',
          alertTitle: 'Duplicate cities detected',
          alertDescription: `The following cities are already added to this job: ${duplicates.map(c => `${c.city}, ${c.state}`).join(', ')}`,
        });
        return false;
      }

      return true;
    },
    async handleCreate() {
      if (!this.validateLocation()) {
        this.handleValidationError();
        return;
      }

      try {
        const promises = this.selectedCities.map(city =>
          createJobLocation(
            { id: this.record.id },
            {
              newJobLocationAttributes: {
                city: city.city,
                state: city.state,
                country: city.country || 'USA',
                latitude: city.latitude,
                longitude: city.longitude,
                status: 'active',
              },
            }
          )
        );

        await Promise.all(promises);
        this.handleSuccess();
      } catch (error) {
        this.handleError(error);
      }
    },
    handleValidationError() {
      if (this.$refs.modal && typeof this.$refs.modal.error === 'function') {
        this.$refs.modal.error();
      } else {
        this.$store.commit('general/hideLocalLoadingSpinner');
      }
    },
    handleSuccess() {
      if (this.$refs.modal && typeof this.$refs.modal.success === 'function') {
        this.$refs.modal.success();
      } else {
        this.$store.commit('general/hideLocalLoadingSpinner');
      }

      this.$emit('handleJobCityNewCreate');

      this.$store.commit('general/showAlert', {
        alertType: 'success',
        alertTitle: 'Job city/cities added',
        alertDescription:
          'Your city/cities were successfully added. Use the buttons below to view your job, or dismiss this alert.',
        alertUrl: `/jobs/${this.record.title}`,
      });
    },
    handleError(error) {
      console.error('Error creating job location:', error);
      this.$store.commit('general/showAlert', {
        alertType: 'error',
        alertTitle: 'Error adding city',
        alertDescription: error.message || 'An error occurred while adding the city. Please try again.',
      });
    },
    handleCancel() {
      this.$emit('handleJobCityNewCancel');
    },
  },
};
</script>
